import React, { Component } from 'react'
import { connect } from 'react-redux'
import BatchCloseSample from '../samples/BatchCloseSample'
import { makeBatchClose } from '../../../actions/transactionsActions'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    ECR: ["batchclose.SetEcrno(ecr_no);", "batchclose.setEcrno(ecr_no);", "ecr_number=>$ecr_number"],
}

class BatchClose extends Component {
    onMakeBatchClosePress() {
        const { storeId, apiToken, ecrNumber, batchCloseSuccess } = this.props;

        if(!batchCloseSuccess) {
            const batchCloseRequest = { storeId, apiToken, ecrNumber };
            this.props.makeBatchClose(batchCloseRequest);
        }
        else {
            return null
        }
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Force Post</h3>
                <BatchCloseSample />
                <div className="requestButton" onClick={() => this.onMakeBatchClosePress()}>
                    Batch Close Request
                </div> 
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Batch Close</b></span>
                <p style={{marginTop: '3vh'}}>Takes the funds from all Purchase, Completion, Refund and Force Post transactions so that they will be deposited or debited the following business day.</p>
                <p>For funds to be deposited the following business day, the batch must close before 11 pm Eastern Time.</p>

                <p><b>Batch Close transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>BatchClose batchclose = new BatchClose();</code>
                    case _JAVA:
                        return <code>BatchClose batchclose = new BatchClose();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’batchclose', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Batch Close transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(batchclose);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(batchclose);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Batch Close transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>ECR (electronic cash register) number</td>
                        <td><i>String</i><br /><br />No limit (value provided by Moneris)</td>
                        <td><code>{CODES.ECR[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, ecrNumber } = state.transactions.main.config;
    const { batchCloseSuccess } = state.transactions.main;
    return { mode, storeId, apiToken, ecrNumber, progLangId: state.common.progLangList.selection, batchCloseSuccess };
}

export default connect(mapStateToProps, {makeBatchClose})(BatchClose)
